import React, { useState, useContext, useEffect } from "react";
import Steppers from "../../../components/Steppers";
import { useTranslation } from "react-i18next";
import classes from "./Store.module.scss";
import { useNavigate } from "react-router";
import * as r from "../../../constants/routes";
import RoundButton from "../../../components/Buttons/RoundButton";
import * as api from "../../../constants/api";
import useFetch from "../../../hooks/useFetch";
import SessionContext, {
  SessionInterface,
} from "../../../context/sessionContext";
import Spinner from "../../../components/Spinner";
import ProductSelectionCard from "./pages/ProductSelectionCard";
import ReviewCardCard from "./pages/ReviewCardCard";
import InvoiceForm from "./pages/InvoiceForm";
import PaymentCardInfo from "./pages/PaymentCardInfo";
import { useFormValidation } from "./hooks/useFormValidation";
import PixPaymentCard from "./pages/PixPaymentCard";
import SuccessCard from "./pages/SuccessCard";

export default function Store() {
  const history = useNavigate();
  const cSession: SessionInterface = useContext(SessionContext);
  const adminSub = cSession.admin?.sub ?? "";
  const { t } = useTranslation();

  const [pixInfo, isLoadingPix, errorPix, getPixFetch]: any = useFetch({
    autoInit: false,
  });
  const [productInfo, isLoadingProduct, errorProduct, getProductFetch]: any =
    useFetch({
      autoInit: false,
    });
  const [orderInfo, isLoadingOrder, errorOrder, getOrderInfo]: any = useFetch({
    autoInit: false,
  });

  //!Vai passar o orderID para pegar a nota fiscal

  const [termsCheckBox, setTermsCheckBox] = useState<boolean>(false);

  const [qntOfJourneys, setQntOfJourneys] = useState<number>(0);

  const [stage, setStage] = useState<number>(1);
  const [productChoosed, setProductChoosed] = useState<number>(0);
  const [permission, setPermission] = useState<any>({
    audiofoco_journey: 0,
  });
  const [userInfo, setUserInfo] = useState<any>({
    name: "",
    professional_ssn: "",
    country: "",
    cep: "",
    state: "",
    city: "",
    neighborhood: "",
    street: "",
    number: "",
  });

  const { isInvoiceDataFilled, setIsInvoiceDataFilled } =
    useFormValidation(setUserInfo);

  const _steppers = (
    <Steppers
      stage={stage}
      steppes={[1, 2, 3]}
      showLabels={false}
      showInsideLabel={true}
      horizontal
      checkAll
      showBottonInfo={true}
    />
  );

  useEffect(() => {
    // se o botão voltar for clicado e voltar para o stage 1, resetar as informações
    if (stage === 1) setQntOfJourneys(0);
  }, [stage]);

  useEffect(() => {
    getProductFetch({
      method: "GET",
      url: api.API_PRO_GET_PRODUCT,
      onSuccess: (data: any) => {},
      onError: (error: any) => {
        console.error("Erro ao obter informações do produto:", error);
      },
    });
  }, []);

  useEffect(() => {
    if (productInfo && productInfo.length > 0)
      setPermission(
        productInfo[productChoosed]?.permissions ?? { audiofoco_journey: 0 },
      );
  }, [productInfo, productChoosed]);

  const topContent = <>{_steppers}</>;

  const detailsCard = (
    <>
      {!isLoadingProduct ? (
        <ProductSelectionCard
          qntOfJourneys={qntOfJourneys}
          productInfo={productInfo}
          permission={permission}
          setQntOfJourneys={setQntOfJourneys}
          setProductChoosed={setProductChoosed}
          stage={stage}
          setStage={setStage}
        />
      ) : (
        <Spinner />
      )}
    </>
  );

  const reviewCard = (
    <>
      {!isLoadingProduct ? (
        <ReviewCardCard
          setTermsCheckBox={setTermsCheckBox}
          qntOfJourneys={qntOfJourneys}
          productInfo={productInfo}
          stage={stage}
          setStage={setStage}
          productChoosed={productChoosed}
          isInvoiceDataFilled={isInvoiceDataFilled}
          userInfo={userInfo}
          termsCheckBox={termsCheckBox}
          getPixFetch={getPixFetch}
          cSession={cSession}
          adminSub={adminSub}
        />
      ) : (
        <Spinner />
      )}
    </>
  );

  const cardsAreaDetails = (
    <div className={classes.CardsArea}>
      {detailsCard}
      {reviewCard}
    </div>
  );

  const cardPaymentInfo = (
    <InvoiceForm setUserInfo={setUserInfo} userInfo={userInfo} />
  );
  const invoiceCard = (
    <div className={classes.InvoiceCard}>
      {cardPaymentInfo}
      {reviewCard}
    </div>
  );

  const paymentCardInfo = (
    <PaymentCardInfo
      termsCheckBox={termsCheckBox}
      setTermsCheckBox={setTermsCheckBox}
    />
  );

  const paymentCard = (
    <div className={classes.PaymentCard}>
      {paymentCardInfo}
      {reviewCard}
    </div>
  );
  // exemplo de resposta do pixInfo
  // {
  //     "emv": "00020126910014BR.GOV.BCB.PIX2569api-pix-h.bancobs2.com.br/spi/v2/af4d2ed5-bb34-4b04-89e0-1dc441d943f0520400005303986540560.005802BR5905Yapay6014Belo Horizonte61083038040362070503***6304CA8B",
  //     "expiration_date": "2026-02-22T17:18:54",
  //     "orderID": 19730695,
  //     "order_id": "1:2026-02-20 20:18:50",
  //     "order_last_id": "1:2026-02-20 20:18:50",
  //     "order_status": "AP",
  //     "qrcode": "https://d3qiiqeqvrl56p.cloudfront.net/sandbox/2023/05/04/bs2/N887275971_qrcode.svg"
  // }

  const forceFinalScreen = false;

  const pixCard = (
    <PixPaymentCard pixInfo={pixInfo} isLoadingPix={isLoadingPix} />
  );

  const completeOperation = (
    <SuccessCard qntOfJourneys={qntOfJourneys} productInfo={productInfo} pixInfo={pixInfo} productChoosed={productChoosed} />
  );

  const erroCreatePix = (
    <div className={classes.ErroCreatePix}>
      <h2>{t("purchase.error_creating_pix")}</h2>
      <p>{t("purchase.error_creating_pix_info")}</p>
      <div className={classes.CompleteOperationButton}>
        <RoundButton
          onClick={() => history(r.R_A_ROOT)}
          text={t("global.go_back_to_home")}
          title={t("global.go_back_to_home")}
        />
      </div>
    </div>
  );
  let count = 0;
  useEffect(() => {
    if (stage === 4 && pixInfo?.qrcode) {
      if (adminSub && pixInfo?.orderID) {
        const interval = setInterval(() => {
          getOrderInfo({
            method: "GET",
            url:
              api.API_PRO_GET_ORDER_INFO +
              "?sub=" +
              adminSub +
              "&order_id=" +
              pixInfo.order_id,
            onSuccess: (data: any) => {},
            onError: (error: any) => {
              console.error("Erro ao obter informações do pedido:", error);
            },
          });
          count += 1;
          if (count === 100) return history("/");
        }, 20000);
        return () => clearInterval(interval);
      }
    }
  }, [stage, pixInfo?.qrcode]);

  useEffect(() => {
    if (orderInfo?.status === "PG") setStage(5);
  }, [orderInfo]);

  useEffect(() => {
    const missingFields = Object.keys(userInfo).filter(
      (key) => key !== "complement" && !userInfo[key],
    );
    if (missingFields.length === 0) {
      setIsInvoiceDataFilled(true);
    } else {
      setIsInvoiceDataFilled(false);
    }
  }, [userInfo]);

  const _holderContent: { [key: string]: JSX.Element } = {
    "1": cardsAreaDetails,
    "2": invoiceCard,
    "3": paymentCard,
    "4": pixCard,
    "5": completeOperation,
    "6": erroCreatePix,
  };

  const _content = (
    <>
      {topContent}
      {_holderContent[forceFinalScreen ? "5" : String(stage)]}
    </>
  );
  return _content;
}
